import React from 'react';
import { cn } from '../lib/cn';

/**
 * Badge — Etiqueta pequeña de estado/categoría.
 *
 * Variants:
 *   primary | success | warning | danger | info | secondary
 *
 * Uso:
 *   <Badge variant="success">¡Hoy!</Badge>
 *   <Badge variant="warning">Cambio pendiente</Badge>
 */
const VARIANTS = {
    primary:   'bg-[hsl(var(--brand-light))]/10 text-[hsl(var(--brand-light))]',
    success:   'bg-[hsl(var(--success-bg))] text-[hsl(var(--success-fg))]',
    warning:   'bg-[hsl(var(--warning-bg))] text-[hsl(var(--warning-fg))]',
    danger:    'bg-[hsl(var(--danger-bg))] text-[hsl(var(--danger-fg))]',
    info:      'bg-[hsl(var(--info-bg))] text-[hsl(var(--info-fg))]',
    secondary: 'bg-slate-100 text-slate-700',
};

export const Badge = ({ variant = 'secondary', className, children, ...props }) => (
    <span
        className={cn(
            'inline-flex items-center gap-1 px-2 py-0.5 rounded-md',
            'text-[10px] font-semibold leading-none whitespace-nowrap',
            VARIANTS[variant],
            className
        )}
        {...props}
    >
        {children}
    </span>
);
